// ** Redux Imports
import { combineReducers } from 'redux';

// ** Reducers Imports
import userSlice from './slice/userSlice';
import roleSlice from './slice//roleSlice';
import orgSlice from './slice//orgSlice';

const rootReducer = combineReducers({
  user: userSlice.reducer,
  role: roleSlice.reducer,
  org: orgSlice.reducer
});

export default rootReducer;
